<template>
    <div class="ApplicantCredentials q-px-md q-pt-md">
        <div rounded class="">
            <div class="row">
                <div class="col-xs-12 col-md-6 col-lg-5 col-xl-4" style="margin: auto;">
                    <b>User ID *</b>
                    <!-- label="* User ID" -->
                    <q-input ref="input" outlined  v-model="StoreStateAD.Creation_loginUserID"  bottom-slots  :rules="[val => !!val || '' + $t('common.fieldRequired') +' ', isValidEmail]"  >
                        <template v-slot:prepend>
                            <q-icon name="far fa-user-circle"/>
                        </template>
                    </q-input>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-md-6 col-lg-5 col-xl-4" style="margin: auto;">
                    <b>Password</b>
                    <q-input outlined v-model="StoreStateAD.Creation_LoginPassword"  v-bind:type="StoreStateAD.isPwd ? 'password' : ''" :rules="[val => !!val || '' + $t('common.fieldRequired') +' ', isStrongPassword]" ref="fldPasswordChange">
                        <template v-slot:prepend>
                            <q-icon name="lock" />
                        </template>
                        <template v-slot:append>
                            <q-icon :name="StoreStateAD.isPwd ? 'visibility_off' : 'visibility'" class="cursor-pointer" v-on:click="StoreStateAD.isPwd = !StoreStateAD.isPwd"></q-icon>
                        </template>
                    </q-input>
                </div>
                </div>
            <div class="row">
                <div class="col-xs-12 col-md-6 col-lg-5 col-xl-4" style="margin: auto; margin-top: 8px;">
                    <b>Confirm your password</b>
                    <q-input outlined v-model="StoreStateAD.passwordConfirm"  v-bind:type="StoreStateAD.isPwd ? 'password' : ''" lazy-rules v-bind:rules="ConfirmPWD" v-on:keyup="comparePwd" ref="fldPasswordChangeConfirm">
                        <template v-slot:prepend>
                            <q-icon name="lock" />
                        </template>
                        <template v-slot:append>
                            <q-icon :name="StoreStateAD.isPwd ? 'visibility_off' : 'visibility'" class="cursor-pointer" v-on:click="StoreStateAD.isPwd = !StoreStateAD.isPwd"></q-icon>
                        </template>
                    </q-input>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
.row > div {
  padding: 10px 15px
}
</style>


<script>
import store from '../store';
export default {
    name: 'ApplicantCredentials',
	data () {
		return {
			StoreStateAD : store.state.AD
        }
    },
	mounted () {
  	},
  	computed: {
          
        isValidUserID () {
            
            if(this.StoreStateAD.userID.length <= 10){
                this.StoreStateAD.SubmitApplicantCredential= true;
            }else{
                this.StoreStateAD.SubmitApplicantCredential= false;
            }
            return this.StoreStateAD.userID.length <= 10
        },
        ConfirmPWD() {
            
           
          if((v) => !!v ){
                this.StoreStateAD.SubmitApplicantCredential= true;
          }else{
                this.StoreStateAD.SubmitApplicantCredential= false;
          }
            return [
                (v) => !!v || "*Required",
                (v) => v == this.$refs.fldPasswordChange.value || "Password does not match!"
                ]
        },
        PasswordRequired() {            
            if((v) => !!v ){
                this.StoreStateAD.SubmitApplicantCredential= true;
            }else{                
                this.StoreStateAD.SubmitApplicantCredential= false
            }
            return [(v) => !!v || '*Required']
        }


    },methods:{
        isValidEmail:function (val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || 'Invalid email';
        },
        isStrongPassword:function(val){
            const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
            return strongRegex.test(val) || 'Password must be alphanumeric, contains uppercase letter & special characters !@#\$%\^&\ . Min 8 Characters';
        },
        comparePwd: function(){
            if(this.$refs.fldPasswordChangeConfirm.value == this.$refs.fldPasswordChange.value){
                this.StoreStateAD.SamePassword= true;
            }else{ 
                this.StoreStateAD.SamePassword= false;
            }
        }
    }
  
}
</script>